/**
 * @module attributeValueResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeAttributeValueResults = (state, action) => {
  const attributeValueResults = action.payload?.entities?.attributeValueResults || {};

  return { ...state, ...attributeValueResults };
};

const attributeValueResults = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeAttributeValueResults);

  builder.addCase(surveyReportingActions.fetchReportingAttributeResult.fulfilled, mergeAttributeValueResults);
});

export default attributeValueResults;
